export const delay = (n: number) => new Promise(accept => setTimeout(accept, n));